import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { ICustomsPost } from '../interfaces';
import { CustomsPostMapper } from '../mappers';

export type IGetCustomsPostsRepoResponse = IRepoResponse<200, { data: ICustomsPost[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetCustomsPostsRepo = IRepo<[any], IGetCustomsPostsRepoResponse>;

export const GetCustomsPostsRepoType = Symbol.for('GetCustomsPostsRepo');

@bind(GetCustomsPostsRepoType)
export class GetCustomsPostsRepo implements IGetCustomsPostsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: any) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/customs/carriersposts', query) });

      if (result.status === 200) {
        const data: ICustomsPost[] = result.data.data.map((item) => CustomsPostMapper.toDomain(item));

        return {
          status: 200 as 200,
          response: {
            data,
            total: data.length >= query.limit ? query.limit + query.offset + 1 : query.limit + query.offset,
          },
        };
      } else if (result.status === 400) {
        return {
          status: 400 as 400,
          response: Object.values(result.data.errors).flat().join('. '),
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
